import React from 'react';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import {Provider} from 'react-redux';

import {store} from './redux/index.js';

import Error from 'components/error.js';
import RorschachPage from 'pages/rorschach/rorschach-page';
import Layout from 'pages/layout.js';

global.NODE_ENV = process.env.NODE_ENV;

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <Error />,
    children: [
      {
        path: 'projects/:projectId/rorschach',
        element: <RorschachPage />,
      },
      {
        index: true,
        path: '*',
        element: <div>404</div>
      }
    ],
  },
]);

export default function App() {
  return (
    <Provider {...{store}}>
      <RouterProvider router={router} fallbackElement={<Fallback />} />
    </Provider>
  );
}

export function Fallback() {
  return <p>Performing initial data load</p>;
}
